import React, { useState, useEffect } from "react";
import { HOUR_HEIGHT, TIME_COLUMN_WIDTH, CURRENT_TIME_COLOR } from "./CalendarConstants";

/**
 * Red line (+ optional dot) showing current time, updates every minute.
 * variant="day"  → dot + line with time-column offset
 * variant="week" → simple red line, no dot
 */
const CurrentTimeIndicator = ({ variant = "day" }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(id);
  }, []);

  const top = (now.getHours() + now.getMinutes() / 60) * HOUR_HEIGHT;

  if (variant === "week") {
    return (
      <div style={{
        position: "absolute",
        top,
        left: 0,
        right: 0,
        height: 2,
        backgroundColor: CURRENT_TIME_COLOR,
        zIndex: 3,
        pointerEvents: "none",
      }} />
    );
  }

  // Day variant: dot + line
  return (
    <div style={{
      position: "absolute",
      top: top - 5,
      left: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      zIndex: 3,
      pointerEvents: "none",
    }}>
      <div style={{ width: TIME_COLUMN_WIDTH - 6, flexShrink: 0 }} />
      <div style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: CURRENT_TIME_COLOR,
        flexShrink: 0,
      }} />
      <div style={{
        flex: 1,
        height: 2,
        backgroundColor: CURRENT_TIME_COLOR,
      }} />
    </div>
  );
};

export default React.memo(CurrentTimeIndicator);
